import { GET_BRANDS, GET_CATEGORIES, GET_PRODUCTS, GET_SUB_CATEGORIES, GET_SWIPPED } from "../ConstAction";

export const getCategories = (data) => {
  return {
    type: GET_CATEGORIES,
  };
};

export const getsubCategories = (data, setLoading) => {
  return {
    type: GET_SUB_CATEGORIES,
    data: data,
    setLoading: setLoading
  };
};

export const getBrands = (data) => {
  return {
    type: GET_BRANDS,
    data: data
  };
};


export const getSwipped = (data) => {
  return {
    type: GET_SWIPPED,
    data: data
  };
};

